var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_673_25192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.98022V4.50009V19.4054V21.9385L10.2697 20.0885L5.8896 15.4054H3.23529C2.00078 15.4054 1 14.4046 1 13.1701V10.6995C1 9.46497 2.00077 8.4642 3.23529 8.4642H5.89173L10.2721 3.81438L12 1.98022ZM10 7.01995L7.05141 10.1499L6.75533 10.4642H6.32353H3.23529C3.10534 10.4642 3 10.5695 3 10.6995V13.1701C3 13.3 3.10534 13.4054 3.23529 13.4054H6.32353H6.75746L7.05387 13.7223L10 16.8722V7.01995ZM14.3528 21.9094C19.2358 21.2491 22.9999 17.0642 22.9999 12.0002C22.9999 6.93615 19.2358 2.75129 14.3528 2.09091V4.11408C18.1268 4.75688 20.9999 8.043 20.9999 12.0002C20.9999 15.9573 18.1268 19.2435 14.3528 19.8863V21.9094ZM18.5 12.0002C18.5 14.6206 16.7471 16.8317 14.3499 17.5247V15.3928C15.6207 14.7924 16.5 13.499 16.5 12.0002C16.5 10.5014 15.6207 9.20795 14.3499 8.60759V6.47567C16.7471 7.16867 18.5 9.37971 18.5 12.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_673_25192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.eed75efdf91b4773977f1ef8066bf00f.svg";
export { ForwardRef as ReactComponent };